export default {
  title: 'Modificatori',
  master_title: 'Modalità marchio - Modificatori',
  products_creation_disabled:
    "A causa dell'integrazione attiva con {{integration}}, la creazione di nuovi prodotti non è consentita. Per modificare il menu, effettua le modifiche in {{integration}} e sincronizza il menu.",
  labels: {
    select_all: 'Seleziona tutto',
  },
  buttons: {
    add_modifier: 'Aggiungi modificatore',
    delete_selected: 'Elimina selezionati',
    refresh: 'Aggiorna',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati fallito',
  },
};
